import {isArray, map} from 'lodash'

const getClassGenerator = (prefix) => {
    return (clazz = '') => {
        if (isArray(clazz)) {
           return map(clazz, c => `${prefix}-${c}`).join(' ')
        }
        return `${prefix}-${clazz}`
    }
}

export default {
    getClassGenerator,
}
